import React, { memo, useCallback } from 'react';
import { Drawer } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as FilterIcon } from '../../../../../resource/FilterDocumentIcon.svg';
import { filterActions } from '../../model/actions';
import { selectTotalActiveCount } from '../../model/activity';
import {
  RequestFilterCommandsProvider,
  useRequestFilterCommands,
} from '../../model/commandsContext';
import {
  RequestFilterSectionExpansionProvider,
  useRequestFilterSectionExpansion,
} from '../../model/sectionExpansionContext';
import FilterContainer from '../FilterContainer';
import styles from './FilterDrawer.module.scss';

const FilterHeader = memo(() => {
  const activeCount = useSelector(selectTotalActiveCount);
  const { allSectionsExpanded, toggleAllSections } =
    useRequestFilterSectionExpansion();

  return (
    <div className={styles.header}>
      <span className={styles.titleBlock}>
        <FilterIcon />
        <span>Фильтр заявок</span>
        {activeCount > 0 && (
          <span
            className={styles.activeCount}
            title={`Активных параметров: ${activeCount}`}
          >
            {activeCount}
          </span>
        )}
      </span>

      <button
        type="button"
        className={styles.toggleAllButton}
        onClick={toggleAllSections}
      >
        {allSectionsExpanded ? 'Скрыть все' : 'Раскрыть все'}
      </button>
    </div>
  );
});

const FilterDrawerContent = () => {
  const dispatch = useDispatch();
  const filterCommands = useRequestFilterCommands();
  const visible = useSelector((state) => state.requestsStore.filterVisible);
  const filterChanged = useSelector((state) => state.filterStore.filterChanged);

  const handleClose = useCallback(() => {
    dispatch(filterCommands.closeFilter(false));

    if (filterChanged) {
      dispatch(filterCommands.fetchRequests());
      dispatch(filterActions.setFilterChanged(false));
    }
  }, [dispatch, filterChanged, filterCommands]);

  return (
    <Drawer
      visible={visible}
      title={<FilterHeader />}
      width="min(760px, 100vw)"
      headerStyle={{ position: 'sticky', top: 0, zIndex: 10 }}
      closable={true}
      drawerStyle={{ backgroundColor: '#f3f7ff' }}
      bodyStyle={{
        padding: 0,
      }}
      className={styles.drawer}
      onClose={handleClose}
    >
      <FilterContainer />
    </Drawer>
  );
};

const FilterDrawer = ({ commands }) => (
  <RequestFilterCommandsProvider commands={commands}>
    <RequestFilterSectionExpansionProvider>
      <FilterDrawerContent />
    </RequestFilterSectionExpansionProvider>
  </RequestFilterCommandsProvider>
);

export default memo(FilterDrawer);
